import React, { Component } from "react";
import {
  Grid,
  Button,
  Typography,
  ButtonGroup
} from "@material-ui/core";
import { FIND_POSTS } from '../../graphql/queries/posts';
import { connect } from "react-redux";
import {client} from '../../config/apollo';

import {
  fetchFeaturedPosts,
  fetchPosts,
  fetchPostsDrafted
} from "../../redux/posts";
import {primaryColor, textBlack, textGrey, webFont} from "../../config/theme";
import SinglePost from "./SinglePost";
import './style.css';
const defaultImg = "/images/orange-logo-white-bg.webp";

class PList extends Component {
  state = {
    postsList: [],
    loading: false,
    isLoaded: false,
    isLive: true
  };

  fetchPosts = query => {
    this.setState({ loading: true });
    client
      .query({
        query: FIND_POSTS,
        variables: query
      })
      .then(resp => {
        this.setState({ loading: false });

        if (resp.data) {
          if (resp.data.posts) {
            this.setState({ postsList: resp.data.posts.posts });
          }
        }
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        console.log(errorObj);
        this.setState({ loading: false });
      });
  };

  componentDidMount() {
    if (!this.props.featured) {
      this.updateList();
      if (this.props.isChef) {
        this.fetchDrafted();
      }
    } else {
      this.fetchFeatured();
    }

    if (!this.props.isChef) {
      this.setState({ isLive: true });
    }
  }

  fetchFeatured = () => {
    this.props.dispatch(fetchFeaturedPosts(this.props.pageSize));
  };

  fetchDrafted = () => {
    this.props.dispatch(
      fetchPostsDrafted({
        filters: {
          chefId: this.props.userId,
          isDraft: true
        }
      })
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters !== this.props.filters) {
      //this.updateList();
      //this.fetchDrafted();
      this.fetchPosts({filters: {...nextProps.filters, isDraft: false}});
    }
  }

  updateList = () => {
    const { filters, pageSize, next, previous, page } = this.props;
    const allFilters = { ...filters };

    page === "portfolio"
      ? this.props.dispatch(
          fetchPosts({
            filters: {
              chefId: this.props.userId,
              isDraft: false
            }
          })
        ) && this.props.dispatch(
      fetchPostsDrafted({
        filters: {
          chefId: this.props.userId,
          isDraft: true
        }
      })
    )
      : this.props.dispatch(
          fetchPosts({
            filters: allFilters,
            pageSize,
            next,
            previous
          })
        );
  };

  handleClick = post => {
    const { history, userId, isChef } = this.props;
    if (isChef && userId === post.chefId) {
      history.push("/home/add-post", { post });
    } else {
      history.push("/home/post-details", { postId: post.id, screen: 'post-search' });
    }
  };

  handleAlignment = (e) => {
    this.setState({isLive:!this.state.isLive});
  };

  render() {
    const { posts, drafted} = this.props.posts;
    let {isLive, postsList}=this.state;
    let {isLiveShow,isShowAll, searching, pageSize}=this.props;
    let combined = [];

    if(isLiveShow)
      combined= isLive ? posts : drafted;
    else if (isLive) {
      if (searching) {
        if (postsList.length > 0) {
          combined = postsList;
        }
      }
      else {
        combined = [...(new Set([...posts, ...postsList]))];
        if (this.props.isChef) {
          combined = [...(new Set([...posts, ...postsList, ...drafted]))];
        }
      }
    }
    else {
      if (this.props.isChef) {
        combined = [...(new Set([...drafted, ...postsList]))];
      } else {
        combined = [...(new Set([...postsList]))];
      }
    }

    let updatedPosts = [];

    combined.forEach(postItem => {
      const index = updatedPosts.findIndex(item => item.id === postItem.id);
      if (index < 0) {
        updatedPosts.push(postItem);
      }
    });

    updatedPosts.sort((a, b) => b.updatedAt - a.updatedAt);

    /*if (updatedPosts.length < 4) {
      isShowAll = false;
    }*/

    if (pageSize && !isNaN(pageSize)) {
      updatedPosts = updatedPosts.slice(0, pageSize);
    }

    const generatePosts = updatedPosts.map((post, index) => {
      const bodyLength = post.body ? post.body.length : 0;

      let postImg = defaultImg;
      if (post.media) {
        if (post.media.length > 0) {
          const length = post.media.length;
          const index = post.media.findIndex(item => item.size === "MEDIUM");
          if (index < 0) {
            postImg = post.media[length - 1].url;
          } else {
            postImg = post.media[index].url;
          }
        }
      }

      // if (this.props.page === "portfolio") {
      return (
	      <Grid data-test-id={"pfpostlistid"} className="featured-post-item" key={index.toString()}>
          <SinglePost
            post={post}
            index={index}
            page={"portfolio"}
            handleClick={this.handleClick}
            isChef={this.props.isChef}
          />
        </Grid>
      );
    });

    const styleButton = {
      toggleItemSelect: {
        backgroundColor: isLive ? "#ff8000" : "#ffffff",
        color: !isLive ? "#ff8000" : "#ffffff",
        borderBottomLeftRadius: 50,
        borderTopLeftRadius: 50,
        borderColor:primaryColor, borderStyle:'solid',
        width: 120,
        textTransform: 'none',
        fontSize: 18,
      },
      toggleItemUnselect: {
        backgroundColor: !isLive ? "#ff8000" : "#ffffff",
        color: isLive ? "#ff8000" : "#ffffff",
        borderBottomRightRadius: 50,
        borderColor:primaryColor, borderStyle:'solid',
        borderTopRightRadius: 50,
        width: 120,
        height: 44,
        textTransform: 'none',
        fontSize: 18,
      }
    };

    const { loading} = this.props.posts;

    return (
      <Grid className="dish-container feature-list-container" container direction="row" style={style.ftGrid}>


        {isLiveShow &&
        <Grid container lg={12} xl={12} sm={12} xs={12} justify={'center'} style={{ marginBottom: 40}}>
          <ButtonGroup
              onClick={this.handleAlignment.bind(this)}
          >
            <Button  data-test-id={"livebtn"} value="left" style={styleButton.toggleItemSelect} >
              Live
            </Button>
            <Button  data-test-id={"draftbtn"} value="right" style={styleButton.toggleItemUnselect }>
              <Typography>Drafts</Typography>
            </Button>
          </ButtonGroup>
        </Grid>}
        <div className="post-custom-container">
          {generatePosts}
        </div>

        {updatedPosts.length <= 0 && !loading && this.props.page === 'portfolio' && (
            <Grid container alignItems="center" justify="center" style={{
              backgroundColor: '#e8e8e8',
              border: '2px solid #ff8000',
              paddingTop: 100,
              paddingBottom: 100
            }}
              onClick={this.props.addPostClick}
            >
              <Typography
                  variant="h5"
                  style={{  fontFamily: webFont,
                    color: textBlack,
                    fontWeight: 500,
                    marginBottom: 30,
                    width: '100%',
                    textAlign: 'center',
                    marginTop: 30 }}
              >
                Add a post
              </Typography>
            </Grid>
        )}

        {updatedPosts.length <= 0 && !loading && this.props.page !== 'portfolio' && (
          <Grid container alignItems="center" justify="center">
            <Typography
              variant="h5"
              style={{  fontFamily: webFont,
                color: textBlack,
                fontWeight: 500,
                marginBottom: 30,
                width: '100%',
                textAlign: 'center',
                marginTop: 30 }}
            >
              No posts found.
            </Typography>
          </Grid>
        )}

        {isShowAll && updatedPosts.length > 0 &&
        <Grid
          container
          alignItems="center"
          justify="center"
          style={{ marginTop: 30 }}
        >
          <Button
            data-test-id={"postshowall"}
            variant="contained"
            color="primary"
            style={style.showBtn}
            onClick={() => this.props.history.push("/home/post-search")}
          >
            Show All
          </Button>
        </Grid>}


      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    posts: state.posts,
    isChef: state.auth.isChef
  };
};


const PostsList = connect(mapStateToProps)(PList);

export default PostsList;

const style = {
  avatarImg: {
    width: 292,
    height: 292,
    borderRadius: 0
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    marginLeft: 80,
    weight: 800,
    marginBottom: 30,
    marginTop: 30
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    paddingLeft: 25
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
    paddingLeft: 25
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    padding: '8px 20px',
    textTransform: "none",
    marginTop: 0,
    fontFamily: webFont,
    fontSize: 15,
    fontWeight: 'normal',
    color: '#fff'
  },
  card: {
    //display: "flex"
  },
  details: {
    display: "flex",
    flexDirection: "column"
  },
  content: {
    flex: "1 0 auto"
  },
  cover: {
    width: 151
  },
  setFont: {
    fontFamily: webFont
  },
  littleHeavy: {
    fontWeight: 500,
  },
  moveRight: {
    marginLeft: 10,
    paddingTop: 5,
    paddingBottom: 5
  }
};
